import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import debounce from 'lodash.debounce';
import { Controller, useFormContext } from 'react-hook-form';
import useFetchTasks from '../../../../hooks/tasks/useFetchTasks';
import { setTasksSearchAction } from '../../../../redux/actions/tasksActions';
import SearchableSelect from '../SearchableSelect';

const TaskSelect = ({ disabled, autoFocus = false }) => {
  const {
    control,
    setValue,
    clearErrors,
    formState: { errors },
  } = useFormContext();

  const { tasks } = useFetchTasks({ unpaged: true });
  const dispatch = useDispatch();
  const isMobileView = useSelector((state) => state.screen.isMobileView);

  const selectOptions = tasks.map((task) => {
    return {
      label: task.name,
      value: task,
    };
  });

  const handleInputChange = useMemo(
    () =>
      debounce((newValue) => {
        dispatch(setTasksSearchAction(newValue));
      }, 300),
    [dispatch],
  );

  return (
    <div>
      <label className="input-label">Виберіть послугу</label>
      <Controller
        name="task"
        rules={{ required: "Це поле є обов'язковим" }}
        control={control}
        render={({ field: { onChange, value } }) => (
          <SearchableSelect
            disabled={disabled}
            value={value ? { label: value.name, value: value } : null}
            options={selectOptions}
            autoFocus={autoFocus}
            isMobileView={isMobileView}
            placeholder={'Виберіть послугу'}
            handleInputChange={handleInputChange}
            onChange={(selectedValue) => {
              onChange(selectedValue);
              setValue('hours', selectedValue.hours);
              clearErrors('hours');
            }}
          />
        )}
      />
      {errors['task'] && <span className="text-xs text-contrast1 mt-1">{errors['task'].message}</span>}
    </div>
  );
};
export default TaskSelect;
